import { render, staticRenderFns } from "./PreviewShadow.vue?vue&type=template&id=35f60d86&scoped=true&"
import script from "./PreviewShadow.vue?vue&type=script&lang=js&"
export * from "./PreviewShadow.vue?vue&type=script&lang=js&"
import style0 from "./PreviewShadow.vue?vue&type=style&index=0&id=35f60d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f60d86",
  null
  
)

export default component.exports